import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import ErrorDialog from "../Dialog/ErrorDialog";  
import ConfirmDialog from "../Dialog/ConfirmDialog";
import { useState } from "react";
export default function NewUser()  {
  const [searchParams, setSearchParams] = useSearchParams();

  const [resetCode, setResetCode] = useState(searchParams.get("code"));
  const [email, setEmail] = useState(searchParams.get("email"));
  const [password, setPassword] = useState(null);
  const [passwordConfirm, setPasswordConfirm] = useState(null);
  const [openVerificationModal, setOpenVerificationModal] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  let navigate = useNavigate();

  // Mutations
  const mutation = useMutation(
    () => {
      return axios.post(`${process.env.REACT_APP_API_ROOT}/resetpassword`, {
        email,
        resetCode,
        password
      });
    },
    {
      onSuccess: (data) => {
        if (data.data.success) {
          //localStorage.setItem("tokenmob", data.data.success.token);
          //queryClient.invalidateQueries(["user"]);
          setShowSuccessDialog(true);
          navigate("/login");
        } else {
          setShowErrorDialog(true);
        }
      },
    }
  );

  const onAccept = () => {
    if (!password || password.length < 8) {
      alert("Your password must be at least 8 characters long");
    } else if (password != passwordConfirm) {
      alert("Passwords do not match");
    } else {
      mutation.mutate();
    }
  };

  return (
    <>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Reset Password
          </h2>
        </div>

        <div className="bg-white mt-8 py-8 px-6 shadow sm:rounded-lg sm:mx-auto sm:w-full sm:max-w-md">
          <div className="mb-4">
            <label
              className="block text-grey-darker text-sm font-bold mb-2"
              htmlFor="password"
            >
              New Password
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="appearance-none block w-full px-3 py-2 border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-mobstr-purple focus:border-mobstr-purple sm:text-sm"
              id="password"
              type="password"
              placeholder="Enter New Password"
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-grey-darker text-sm font-bold mb-2"
              htmlFor="password"
            >
              Confirm New Password
            </label>
            <input
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              className="appearance-none block w-full px-3 py-2 border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-mobstr-purple focus:border-mobstr-purple sm:text-sm"
              id="passwordConfirm"
              type="password"
              placeholder="Confirm New Password"
            />
          </div>
          <div className="flex items-center justify-between">
            {!mutation.isLoading && (
              <button
                className="text-white bg-[#2c4251] hover:bg-[#3d627a] font-medium rounded text-sm w-full px-5 py-2.5 text-center"
                type="button"
                onClick={onAccept}
              >
                Reset
              </button>
            )}
            {mutation.isLoading && (
              <button
                disabled
                type="button"
                className="text-white bg-mobstr-purple  focus:ring-4 focus:ring-airnowpurple font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center"
              >
                <svg
                  role="status"
                  className="inline mr-3 w-4 h-4 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
                Loading...
              </button>
            )}
          </div>
        </div>
      </div>
      <ErrorDialog
        title="Error"
        open={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        onConfirm={() => setShowErrorDialog(false)}
      >
        There was an error resetting your password. Please contact your support team. 
      </ErrorDialog>
      <ConfirmDialog
        title="Success"
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        onConfirm={() => setShowSuccessDialog(false)}
        hideNo={true}
      >
        Your password has been reset successfully. Please login to continue.
      </ConfirmDialog>
    </>
  );
}
